import { $_app_server } from '@/_helpers'

export const testsService = {
  //admin actions
  saveTest,
  delTest,
  saveQuestion,
  delQuestion,

  saveVariant,
  delVariant,

  //anonimus actions
  loadTestsList,
  get,
  loadQuestions,
  loadVariants,
  adduser,
  loadusertest,
  saveAnswer,

  getSertificate
  
}

//admin actions
function saveTest (test) {
  return $_app_server.post('admin/test/savetest',test).then(response => response.data)
}

function delTest(id) {
  return $_app_server.delete("admin/test/del/" + id)
}

function saveQuestion (question) {
  return $_app_server.post('admin/test/savequestion',question).then(response => response.data)
}

function delQuestion (questionId) {
  return $_app_server.delete(`admin/test/delquestion/${questionId}`).then(response => response.data)
}

function saveVariant (variant) {
  return $_app_server.post('admin/test/savevariant',variant).then(response => response.data)
}

function delVariant (variantId) {
  return $_app_server.delete(`admin/test/delvariant/${variantId}`).then(response => response.data)
}

//anonimus actions
function loadTestsList () {
  return $_app_server.get('test/list').then(response => response.data)
}

function get (id) {
  return $_app_server.get('test/'+id).then(response => response.data)
}

function loadQuestions (id) {
  return $_app_server.get('test/'+id+'/questions').then(response => response.data)
}

function loadVariants (id) {
  return $_app_server.get('test/question/'+id).then(response => response.data)
}

function adduser (user) {
  return $_app_server.post('test/addtestuser',user).then(response => response.data)
}

function loadusertest (usertest) {
  return $_app_server.post('test/loadusertest',usertest).then(response => response.data)
}

function saveAnswer (answer) {
  return $_app_server.post('test/saveanswer',answer).then(response => response.data)
}

function getSertificate (testid,testuserid) {
  return $_app_server.get(`test/${testid}/getsertificat/${testuserid}`).then(response => response.data)
}